import { FC, useMemo } from 'react';
import cn from 'classnames';
import styled from 'styled-components';

import { COLORS } from '../../constants/colors';
import { Button as UkButton, ButtonProps as UkButtonProps } from '../../uikit/Button';

export { type UkButtonProps as BtnProps };

export const Button: FC<UkButtonProps> = ({ className, style, type, ...props }) => {
  const model = useMemo(
    () => ({
      text: type === 'text',
      secondary: type === 'secondary',
    }),
    [type],
  );

  return (
    <StyledButton {...props} className={cn(className, model)} type={type} style={{ ...style }} />
  );
};

const StyledButton = styled(UkButton)`
  &&& {
    font-weight: 700;
    height: 44px;
    border-radius: 8px;
  }

  // text
  &.text {
    padding-inline: 0;
    color: ${COLORS.systemSky200};
  }

  &.text:disabled {
    color: ${COLORS.systemSky200};
    background: transparent;
    opacity: 0.5;
  }

  &&&.text:not(:disabled):hover {
    color: ${COLORS.systemSky300};
    background: transparent;
  }

  // secondary
  &.secondary {
    background: ${COLORS.systemSky100};
    color: ${COLORS.systemSky200};
  }

  &.secondary:disabled {
    opacity: 0.5;
  }
`;
